import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';

@Component({
  selector: 'request-quote-modal',
  templateUrl: './request-quote-modal.component.html',
  styleUrls: ['./request-quote-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonComponent, I18NextPipe, ModalComponent, ModalFooterDirective]
})
export class RequestQuoteModalComponent {
  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public get reseller() {
    return this.baseModal.data.reseller;
  }
}
